// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-6257ce58]{margin-bottom:1rem;background-color:#fff;text-decoration:none;color:#000;display:inline-flex;justify-content:start;align-items:center;padding:.75rem 0;width:100%}a img[data-v-6257ce58]{margin-right:.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
